
import router from '@/router';
const Tool = new Object();
Tool.install = function(Vue, options) {
    Vue.prototype.JumpTo = function(url, params, isReplace = false) {
        if(isReplace) {
            router.replace({
                path: url,
                params: params
            });
        } else {
            router.push({
                path: url,
                query: params
            });
        } 
    };
    Vue.prototype.JumpBack = function(){
        router.back()
    }

};
export default Tool;